
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { type RingConfig, type DrawCanvasType, DrawCanvas } from '@xt/client/utils/canvas/index'

export type CircleChartsConfig = {
  // 外环半径
  radius: number
  // 圆环厚度
  thickness: number
  // 开始角度（弧度）对应 12 点位置
  startAngle: number
  // 进度填充颜色
  fillColor: string
  // 背景颜色
  bgColor: string
  // 总数
  count: number
  // 已完成数
  process: number
  // 容器宽高
  containerWandH?: number
}

@Component({
  components: {}
})
export default class CircleCharts extends Vue {
  @Prop() config: CircleChartsConfig

  @Ref()
  canvas: HTMLCanvasElement

  drawCanvas: DrawCanvasType

  get containerWandH() {
    return this.config.containerWandH ? this.config.containerWandH : 124
  }

  // 环较宽时半径计算
  get wideRadius() {
    return this.config.thickness > 1 ? this.config.radius - Math.floor(this.config.thickness / 2) : this.config.radius
  }

  // 结束角度
  get endAngle() {
    return this.config.startAngle + (this.config.process / this.config.count) * Math.PI * 2
  }

  // canvas中心点 - (由容器来决定)
  get center() {
    return {
      x: Math.floor(this.containerWandH / 2),
      y: Math.floor(this.containerWandH / 2)
    }
  }

  drawChart() {
    this.drawCanvas = new DrawCanvas({
      canvas: this.canvas,
      config: { containerW: this.containerWandH, containerH: this.containerWandH }
    })
    this.drawCanvas.initCanvas()
    this.drawCanvas.clearDraw()

    const bgConfig: RingConfig = {
      centerX: this.center.x,
      centerY: this.center.y,
      wideRadius: this.wideRadius,
      color: this.config.bgColor,
      lineWidth: this.config.thickness,
      isRound: false
    }

    // 背景环
    this.drawCanvas.drawRing(bgConfig)

    const processConfig: RingConfig = {
      centerX: this.center.x,
      centerY: this.center.y,
      wideRadius: this.wideRadius,
      color: this.config.fillColor,
      lineWidth: this.config.thickness,
      isRound: true,
      startAngle: this.config.startAngle,
      endAngle: this.endAngle
    }

    // 进度环
    this.drawCanvas.drawRing(processConfig)
  }

  created(): void { }

  mounted(): void {
    this.drawChart()
  }

  updated(): void { }

  beforeDestroy(): void {
    this.drawCanvas.clearDraw()
  }

  destroyed(): void { }
}
